import React from 'react';

function Offer() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 20, color: '#F8FAFC', lineHeight: 1.7 }}>
      <h1 style={{ color: '#F7DE8A', marginBottom: 20 }}>Публичная оферта</h1>
      <p style={{ color: '#94A3B8', fontSize: 13, marginBottom: 20 }}>
        Дата последнего обновления: 13 сентября 2026 г.
      </p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>1. Термины</h2>
      <p>1.1. <strong>Сервис</strong> — программное обеспечение Khepri, доступное по адресу khepri.tech.</p>
      <p>1.2. <strong>Пользователь</strong> — лицо, использующее Сервис.</p>
      <p>1.3. <strong>Оператор</strong> — владелец Сервиса Khepri.</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>2. Предмет оферты</h2>
      <p>2.1. Оператор предоставляет Пользователю доступ к функционалу Сервиса на условиях подписки.</p>
      <p>2.2. Пользователь обязуется оплачивать подписку в соответствии с выбранным тарифом.</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>3. Тарифы</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li><strong>Free</strong> — 0 ₽/мес (20 запросов ИИ, базовые функции)</li>
        <li><strong>Economy</strong> — 990 ₽/мес (100 запросов ИИ)</li>
        <li><strong>Autopilot</strong> — 4 990 ₽/мес (безлимит ИИ)</li>
        <li><strong>Production ERP</strong> — 7 990 ₽/мес (безлимит + ERP)</li>
      </ul>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>4. Права и обязанности</h2>
      <p>4.1. Оператор обязуется обеспечить доступ к Сервису 24/7 (за исключением технических работ).</p>
      <p>4.2. Пользователь обязуется не нарушать работу Сервиса и не передавать доступ третьим лицам.</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>5. Ответственность</h2>
      <p>5.1. Оператор не несёт ответственности за решения, принятые на основе данных Сервиса.</p>
      <p>5.2. Оператор не несёт ответственности за временные сбои, вызванные обстоятельствами непреодолимой силы.</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>6. Оплата и возврат</h2>
      <p>6.1. Оплата производится через ЮKassa.</p>
      <p>6.2. Возврат средств возможен в течение 14 дней с момента оплаты.</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>7. Контакты</h2>
      <p>Email: <a href="mailto:info@khepri.tech" style={{ color: '#F7DE8A' }}>info@khepri.tech</a></p>

      <p style={{ marginTop: 40, color: '#94A3B8', fontSize: 12 }}>
        © Khepri, 2026. Все права защищены.
      </p>
    </div>
  );
}

export default Offer;